import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { cn } from "~/lib/utils";

/**
 * Small "x" badge shown on a selected chip to signal it can be cleared.
 */
export const DeselectBadge = () => (
  <span className="absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-full border-[1.5px] border-interface-neutral-6 bg-interface-neutral-0 text-interface-neutral-6 shadow-sm">
    <FontAwesomeIcon icon={faXmark} className="text-[11px]" />
  </span>
);

export type FilterChipProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
};

/**
 * A full-width selectable chip used in the year / class filter columns. When
 * selected it inverts and shows a {@link DeselectBadge}.
 */
export const FilterChip = ({
  label,
  selected,
  onClick,
  className
}: FilterChipProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "relative flex items-center rounded-lg px-4 py-2.5 text-left text-base font-semibold transition-colors",
      {
        "bg-interface-neutral-6 text-interface-neutral-0": selected,
        "bg-interface-neutral-2 text-interface-neutral-6 hover:bg-interface-neutral-3":
          !selected
      },
      className
    )}
  >
    <span className="min-w-0 flex-1 truncate">{label}</span>
    {selected ? <DeselectBadge /> : null}
  </button>
);
